import { ACCOUNT_SLUG_DETAILS } from '../actionTypes';

export const fetchAccountSlugDetails = (action) => ({
  type: ACCOUNT_SLUG_DETAILS.FETCH,
  payload: action.payload,
});
